module.exports = __webpack_public_path__ + "static/media/25-4.3cee4e41.mp3";